import axios from 'axios';
import { maxItemsPerPage, apiUrl } from './index';

export interface LabelsQueryParams {
  page?: number
  perPage?: number | string
  sort?: string
  order?: string
  search?: string
  countries?: string[]
  is_system_label?: number
}

/** Create/update request body — `color`/`country` are sent as codes, unlike the `Label` response shape. */
export interface LabelPayload {
  id?: number
  name?: string
  color?: number
  country?: string
}

export default {
  getItems(options: LabelsQueryParams = {}) {
    const {
      page = 1,
      perPage = maxItemsPerPage,
      sort = '',
      order = 'asc',
      search = '',
      countries = [],
      is_system_label = -1,
    } = options;

    const params: Record<string, unknown> = {
      page,
      sort,
      order,
      search,
      countries,
    };

    if (Number(perPage) > -1) {
      params.per_page = perPage;
    }

    if (is_system_label > -1) {
      params.is_system_label = is_system_label;
    }

    return axios({
      method: 'get',
      url: `${apiUrl}/labels`,
      params,
    });
  },
  createItem(label: LabelPayload) {
    return axios({
      method: 'post',
      url: `${apiUrl}/labels`,
      data: {
        ...label,
      },
    });
  },
  updateItem(label: LabelPayload) {
    return axios({
      method: 'put',
      url: `${apiUrl}/labels/${label.id}`,
      data: {
        ...label,
      },
    });
  },
  getItem({ id }: { id: number }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/labels/${id}`,
    });
  },
  removeItem({ id }: { id: number }) {
    return axios({
      method: 'delete',
      url: `${apiUrl}/labels/${id}`,
    });
  },
};
